import { ServiceBase } from '../api/ServiceBase';

const endpoint = 'produtos'
const endpointFull = 'full_produtos'


async function getProdutosFull() {
    try {
        var data = await ServiceBase.getByParams(`${endpoint}/${endpointFull}`, { 'limit': 10000 });
        return data;
    } catch (e) {
        throw e;
    }
}

export const ProdutoService = {
    getProdutosFull
}